import { FormField, FormItem, FormControl, FormMessage } from '@/components/ui/form';
import { UseFormReturn } from 'react-hook-form';
import { PostFormValues } from '@/hooks/post/usePostForm';
import GolfClubSearch from '@/components/GolfClubSearch';
import { useTranslation } from 'react-i18next';

type LocationSelectorProps = {
  form: UseFormReturn<PostFormValues>;
};

export function LocationSelector({ form }: LocationSelectorProps) {
  const { t } = useTranslation('MGP');

  return (
    <FormField
      control={form.control}
      name="courseId"
      render={() => (
        <FormItem>
          <FormControl>
            <GolfClubSearch
              mode="Select"
              className='ring-2 ring-input/50 shadow-sm rounded-md max-w-96'
              customSearchCaption={t('add_location')}
              onCourseSelect={course => {
                form.setValue('courseId', course.id.toString());
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
